import Credit from "./Credit";
import Service from "./Service";
import { useSelector } from "react-redux";

export default function Controller(props) {
  const { price, refetch, plan } = props;
  const {
    userInfo: {
      wallet: { balance = 0 },
    },
  } = useSelector((state) => state.auth);

  const diff = +balance - price;

  if (diff >= 0) {
    return <Service {...props} />;
  }

  return <Credit diff={diff} />;
}
